import './styles.css'
import * as THREE from 'three'
import React, { useRef, useState, useCallback, useEffect } from 'react'
import { Canvas, createPortal, useFrame, useThree } from '@react-three/fiber'
import { useFBO, useGLTF, useScroll, Text, Image, Scroll, Preload, ScrollControls, MeshTransmissionMaterial } from '@react-three/drei'
import { easing } from 'maath'
import { createRoot } from 'react-dom/client'
import Home from './components/Home';
import Blog from './components/Blog';
import About from './components/About';
import SimpleAbout from './components/SimpleAbout';
import Projects from './components/Projects';
import SplatComponent from './components/SplatComponent';
import SplatComponentArev from './components/SplatComponentArev';
import WebcamComponent from './components/WebcamComponent';
import WebcamComponentR3F from './components/WebcamComponentR3F';
import Overlay from './components/Overlay';
import Photography from './components/Photography'
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import { Perf } from 'r3f-perf'

//Routing and browser history
import { createBrowserHistory } from "history";
import { Router, Link, Route, Routes, useLocation } from "react-router-dom";
import BlogPost1 from './components/BlogPost1'
import BlogPostSIFT from './components/BlogPostSIFT'
import BlogPostIBVS from './components/BlogPostIBVS'
import TemplateArticle from './components/TemplateArticle'
import { MathJaxContext } from 'better-react-mathjax'

const history = createBrowserHistory({ window });

export function BrowserRouter({ children, history }) {
  let [state, dispatch] = React.useReducer((_, action) => action, {
    action: history.action,
    location: history.location
  });

  React.useLayoutEffect(() => history.listen(dispatch), [history]);

  return (
    <Router
      children={children}
      action={state.action}
      location={state.location}
      navigator={history}
    />
  );
}

function Content({ setSplatToggleFn }) {
    const location = useLocation();
    const canvasRoutes = ['/projects/3dgs', '/templateArticle', '/projects/webcam', '/projects/arev'];
    const showCanvas = canvasRoutes.includes(location.pathname);

    return (
        <>
        {showCanvas && (
            <Canvas 
              camera={{ position: [0, 0, 20], fov: 15 }}
              gl={{ antialias: false }}
            >
                <Routes>
                    {/* <Route path="/" element={<Home />} /> */}
                    <Route path="/projects/3dgs" element={<SplatComponent position={[-1.2, 0, 0]} setSplatToggleFn={setSplatToggleFn} />} />
                    <Route path="/projects/arev" element={<SplatComponentArev position={[-1.2, 0, 0]} setSplatToggleFn={setSplatToggleFn} />} />
                    <Route path="/templateArticle" element={<TemplateArticle />} />
                    <Route path="/projects/webcam" element={<WebcamComponentR3F position={[-1.2, 0, 0]}/>} />
                </Routes>
            </Canvas>
        )}
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<SimpleAbout />} />
            <Route path="/articles" element={<Blog />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/photography" element={<Photography />} />
            <Route path="/articles/sift" element={<BlogPostSIFT />} />
            <Route path="/articles/ibvs" element={<BlogPostIBVS />} />
            {/* Canvas-only routes: rendered inside <Canvas> above, listed here to suppress React Router warnings */}
            <Route path="/projects/3dgs" element={null} />
            <Route path="/projects/arev" element={null} />
            <Route path="/templateArticle" element={null} />
            <Route path="/projects/webcam" element={null} />
        </Routes>
        </>
    )
}

export const Logo = () => {
  return (
    <img src="/ArmenianEternity.svg" style={{ position: 'fixed', bottom: 10, left: 5, width: 30 }} />
  );
};

export default function App({ setSplatToggleFn }) {
  return (
    <BrowserRouter history={history}>
      <Content setSplatToggleFn={setSplatToggleFn} />
    </BrowserRouter>
  )
}

function Root() {
  const [splatToggleFn, setSplatToggleFn] = useState(null);
  const [pathname, setPathname] = useState(history.location.pathname);

  useEffect(() => {
    return history.listen(({ location }) => setPathname(location.pathname));
  }, []);

  return (
    <>
      <Navigation/>
      <div className="main-content">
        <App setSplatToggleFn={setSplatToggleFn} />
      </div>
      <Footer splatToggleFn={splatToggleFn} pathname={pathname} />
    </>
  );
}

createRoot(document.getElementById('root')).render(<Root />)
